module.exports = __webpack_public_path__ + "static/media/educate.b5f4c43c.gif";